import React, { useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { Skeleton, Divider, Alert, Table, Row, Col, Button } from "antd";
import { arrayOf, string, func } from "prop-types";
import { useCreateWeeklyWateringLog } from "graphql/mutations";

import {
  getWeeklyWateringLogsHistoricQuery,
  getFieldbookQuery,
} from "@graphql/queries";

const tableProps = {
  size: "middle",
  pagination: false,
};

function FieldbookWeeklyWateringLogsHistoric({
  fieldbookId,
  producersIds,
  afterSubmit,
}) {
  const [create] = useCreateWeeklyWateringLog();
  const mappedIds = producersIds.map(id => id);
  const [selectedRows, setSelectedRows] = useState([]);
  const queryVars = { variables: { where: mappedIds } };
  const { data, error, loading } = useQuery(getWeeklyWateringLogsHistoricQuery, {
    ...queryVars,
  });
  const rowSelection = {
    onChange: (_, selectedRows) => setSelectedRows(selectedRows),
  };
  const columns = [
    {
      dataIndex: "week",
      title: "Semana",
    },
    {
      dataIndex: "mm",
      title: "Registo de Rega (mm)",
    },
    {
      dataIndex: "hours",
      title: "Registo de Rega (horas)",
    },
  ];

  const createMultiple = () => {
    selectedRows.map(fields => {
      const { week, mm, hours } = fields;
      const refetchQueries = [
        {
          query: getFieldbookQuery,
          variables: { id: fieldbookId },
        },
      ].filter(Boolean);

      return create({
        variables: {
          data: {
            fieldbook: {
              connect: { id: fieldbookId },
            },
            week,
            mm,
            hours,
          },
        },
        refetchQueries,
      }).then(() => afterSubmit());
    });
  };

  if (loading) return <Skeleton />;

  if (error) {
    return (
      <Alert
        message="Algo correu mal"
        description={
          <pre>
            <code>{JSON.stringify(error, null, 2)}</code>
          </pre>
        }
        type="error"
        showIcon
      />
    );
  }

  return (
    <>
      {data?.fieldbooks.map(({ id, portion, weeklyWateringLogs }) => (
        <div key={id}>
          <Divider>Parcela: {portion.name}</Divider>

          <Table
            columns={columns}
            dataSource={weeklyWateringLogs}
            rowKey={({ id }) => id}
            pagination={false}
            rowSelection={{
              ...rowSelection,
            }}
            {...tableProps}
          />
        </div>
      ))}

      <Row style={{ marginTop: 30, textAlign: "center" }}>
        <Col span={24}>
          <Button
            type="primary"
            disabled={selectedRows.length < 1}
            onClick={createMultiple}
          >
            {selectedRows.length > 0
              ? `Copiar ${selectedRows.length} registo(s) de rega`
              : `Selecione registo(s) de rega para copiar`}
          </Button>
        </Col>
      </Row>
    </>
  );
}

FieldbookWeeklyWateringLogsHistoric.propTypes = {
  fieldbookId: string.isRequired,
  producersIds: arrayOf(string).isRequired,
  afterSubmit: func.isRequired,
};

export default FieldbookWeeklyWateringLogsHistoric;
